
$(function () {
    $('button[data-realex-form-url]').on('click', function () {
        if (validatePaymentSubmit()) {
            handleRealexRedirectPayment($(this).data('realex-form-url'));
        }
    });
    
    $(document).on('click', 'button[data-edit-item]', function () {
        window.location.href = $(this).data('edit-item');
    });

    $(document).on('click', 'button[data-remove-item]', function () {
        window.location.href = $(this).data('remove-item');
    });

    if ($('#containerRealexEmbedded').length) {
        handleRealexEmbeddedPayment();
    }

    $('#formPayment').on('submit', function (e) {
        if (!validatePaymentSubmit() || isSharedRetailerStripeCheckout()) {
            e.preventDefault();
        }
    });

    $('#formPaymentConfirm').on('submit', function () {
        $('#formPaymentConfirm button').prop('disabled', true);
    });

    $('#checkboxSubscribeExtra1').on('change', function () {
        if ($(this).is(':checked')) {
            $('#containerSubscribeExtra1_Additional').slideDown();
        } else {
            $('#containerSubscribeExtra1_Additional').slideUp();
        }
    });

    $('#paymentBacsButton').on('click', function () {
        if (validatePaymentSubmit()) {
            handleBacsPayment(); 
        }
    });

    checkIfPhoneNumberRequired();

    $('#Country').on('change', function () {
        checkIfPhoneNumberRequired();
    });

    if (isSharedRetailerStripeCheckout()) {
        initializeSharedRetailerStripeCheckout();
    }
});

function checkIfPhoneNumberRequired() {
    if (window.options.phoneNumberNotRequiredCountries === undefined) {
        return;
    }

    var selectedCountry = $('#Country').val();

    if (window.options.phoneNumberNotRequiredCountries.indexOf(selectedCountry) > -1) {
        $('label[for=PhoneNumber] > .required').hide();
        $('[data-valmsg-for="PhoneNumber"]').hide();
        $('#PhoneNumber').removeClass('is-invalid');
    } else {
        $('label[for=PhoneNumber] > .required').show();
        $('[data-valmsg-for="PhoneNumber"]').show();
    }
}

function validatePaymentSubmit() {

    EnterAddressManually();

    var isValid = $('#formPayment').valid();

    if ($('#AcceptTerms').is(':checked')) {
        $('#AcceptTerms').removeClass('is-invalid');
    } else {
        $('#AcceptTerms').addClass('is-invalid');
        isValid = false;
    }

    if ($('.is-invalid').length) {
        scrollTo($('.is-invalid').first().parent(), 100);
    }

    return isValid;
}

function handleRealexRedirectPayment(url) {

    $('#SelectedCard').val('realex');

    $.ajax({
        type: 'POST',
        url: url,
        data: $('#formPayment').serialize(),
        success: function (formHtml) {
            $('body').append(formHtml);
            $('#RealexCheckoutForm').submit();
        },
        error: function (res, status, error) {
            logAjaxFailure('REALEX REDIRECT ERROR', res, status, error);
        }
    });
}

function handleRealexEmbeddedPayment() {

    if (window.addEventListener) {
        window.addEventListener('message', receiveMessage, false);
    } else {
        window.attachEvent('message', receiveMessage);
    }

    const defaultIframeHtml = $('iframe[name="iframeRealexEmbedded"]')[0].outerHTML;

    $('#containerRealexEmbedded_PaymentTypeTabs button.card-tab').on('click', function () {

        if (validatePaymentSubmit()) {

            if ($('#AcceptTerms').is(':checked')) {
                handleRealexEmbeddedPayment_TabToggle('card');
            } else {
                $('#AcceptTerms').prop('checked', true);
            }
        }
    });

    $('#containerRealexEmbedded_PaymentTypeTabs button.paypal-tab').on('click', function () {

        if (validatePaymentSubmit()) {
            handleRealexEmbeddedPayment_TabToggle('paypal');
        }
    });

    $('#AcceptTerms').on('change', function () {

        const $self = $(this);

        if ($self.is(':checked')) {

            if (validatePaymentSubmit()) {

                $('#SelectedCard').val('realex');

                handleRealexEmbeddedPayment_TabToggle('card')

                $.ajax({
                    url: $('#containerRealexEmbedded').data('save-info-url'),
                    type: 'POST',
                    data: $('#formPayment').serialize(),
                    success: function (result) {

                        if (result.success) {

                            togglePaymentFormReadonly(true);

                            $.ajax({
                                url: $('#containerRealexEmbedded').data('realex-form-url'),
                                type: 'GET',
                                dataType: 'html',
                                success: function (formHtml) {
                                    $('#containerRealexEmbedded').show();

                                    $('body').append(formHtml);

                                    $('#RealexCheckoutForm').submit();
                                },
                                error: function (res, status, error) {
                                    logAjaxFailure('REALEX REDIRECT ERROR', res, status, error);
                                }
                            });
                        } else {
                            console.error('SAVE PAYMENT INFO ERROR');
                            console.info(result);
                        }
                    },
                    error: function (res, status, error) {
                        logAjaxFailure('SAVE PAYMENT INFO ERROR', res, status, error);
                    }
                });

            } else {
                $('#AcceptTerms').prop('checked', false);
                $('#AcceptTerms').removeClass('is-valid');
                togglePaymentFormReadonly(false);
            }
        } else {
            $('iframe[name="iframeRealexEmbedded"]').replaceWith(defaultIframeHtml);

            $('#containerRealexEmbedded').hide();
            $('#containerRealexEmbedded_PaymentTypeTabs_PayPalConfirm').hide();

            $('#containerRealexEmbedded_PaymentTypeTabs button.paypal-tab').removeClass('selected');
            $('#containerRealexEmbedded_PaymentTypeTabs button.card-tab').removeClass('selected');

            $('#containerRealexEmbedded_Preview').show();

            togglePaymentFormReadonly(false);
        }
    });
}

function handleRealexEmbeddedPayment_TabToggle(type) {

    if (!$('#containerRealexEmbedded_Preview').hasClass('do-not-hide')) {
        $('#containerRealexEmbedded_Preview').hide();
    }

    if (type === 'card') {

        $('#containerRealexEmbedded_PaymentTypeTabs_PayPalConfirm').hide();
        $('#containerRealexEmbedded').show();

        $('#containerRealexEmbedded_PaymentTypeTabs button.paypal-tab').removeClass('selected');
        $('#containerRealexEmbedded_PaymentTypeTabs button.card-tab').addClass('selected');
    }
    if (type === 'paypal') {

        $('#containerRealexEmbedded').hide();
        $('#containerRealexEmbedded_PaymentTypeTabs_PayPalConfirm').show();

        $('#containerRealexEmbedded_PaymentTypeTabs button.card-tab').removeClass('selected');
        $('#containerRealexEmbedded_PaymentTypeTabs button.paypal-tab').addClass('selected');
    }
}

function handleBacsPayment() {
    $('#BraintreeNonce').val('BYPASS');
    $('#SelectedCard').val('BACS');
    $('#formPayment').submit();
}

function receiveMessage(event) {
    try {

        if (event.origin.indexOf('realex') !== -1) {

            const parsedObj = JSON.parse(event.data);

            if (!(event.data && parsedObj.iframe)) {

                $.ajax({
                    type: 'POST',
                    url: $('#containerRealexEmbedded').data('realex-process-url'),
                    data: JSON.parse(event.data),
                    success: function (data) {
                        console.info(data);
                        $('iframe[name="iframeRealexEmbedded"]').hide();
                        $('#containerRealexEmbedded_Success').show();
                        $('#formPayment').submit();
                    },
                    error: function (res, status, error) {
                        logAjaxFailure('REALEX EMBEDDED ERROR', res, status, error);
                    }
                });
            }
        }

    } catch (ex) {
        console.error('RECEIVE MESSAGE ERROR');
        console.info(ex);
        console.info(event);
    }
}

function logAjaxFailure(message, res, status, error) {
    console.error(message);
    console.info(res);
    console.info(status);
    console.info(error);
    var failureUrl = $("#containerRealexEmbedded").data('payment-error-url');
    if (failureUrl) {
        window.location.replace(failureUrl);
    }
}

function togglePaymentFormReadonly(state) {
    $('#formPayment input').prop('readonly', state);
    $('#formPayment .dropdown-toggle, #paymentSameCheckbox').attr('disabled', state);
    $('#formPayment select').each(function () {

        const $dropdown = $(this);
        $dropdown.prop('disabled', state);

        if (state) {
            $dropdown.after(`<input type="hidden" name="${$dropdown.attr('name')}" value="${$dropdown.val()}">`);
        } else {
            $dropdown.next('input[type="hidden"]').remove();
        }

    });
    if (state) {
        $('.nav-link ').removeClass("terms-clicked");
        $('.nav-link').addClass("terms-clicked");
    } else {
        $('.nav-link ').removeClass("terms-clicked");
    }
    if (state) {
        $('[selenium-identifier="PAYMENT_EDIT-ITEM"]').addClass('disabled');
        $('[selenium-identifier="PAYMENT_REMOVE-ITEM"]').addClass('disabled');
        $('[selenium-identifier="PAYMENT_ADD-ANOTHER"]').addClass('disabled');
    } else {
        $('[selenium-identifier="PAYMENT_EDIT-ITEM"]').removeClass('disabled');
        $('[selenium-identifier="PAYMENT_REMOVE-ITEM"]').removeClass('disabled');
        $('[selenium-identifier="PAYMENT_ADD-ANOTHER"]').removeClass('disabled');
    }
}

function isSharedRetailerStripeCheckout() {
    return $('.shared-retailer-stripe-wrapper #containerStripePaymentElement').length > 0;
}

function initializeSharedRetailerStripeCheckout() {
    $('#AcceptTerms').on('change', function () {
        if (!$(this).is(':checked')) {
            return;
        }

        EnterAddressManually();

        if ($('#formPayment').valid()) {
            window.MountStripePaymentElement();
        } else {
            $(this).prop('checked', false);
        }
    });
}
